export default "__VITE_ASSET__LwApswon__"